import React, { Component } from 'react';

const TERMS_CONTENT_URL = '/terms/terms.json';

class Terms extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: null,
            error: null,
        };
    }

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.language !== this.props.language) {
            this.fetchContent();
        }
    }

    fetchContent() {
        // Cache-bust so edits to the JSON are reflected without a hard refresh
        fetch(`${TERMS_CONTENT_URL}?v=${Date.now()}`)
            .then(res => {
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.json();
            })
            .then(data => this.setState({ content: data, error: null }))
            .catch(err => this.setState({ error: err.message }));
    }

    renderSubsections(subsections) {
        return subsections.map(sub => (
            <div key={sub.id} id={sub.id}>
                <h3>{sub.heading}</h3>
                <p dangerouslySetInnerHTML={{ __html: sub.body }} />
            </div>
        ));
    }

    renderArticles(articles) {
        return articles.map(article => (
            <div key={article.id} id={article.id}>
                <h2>{article.heading}</h2>
                {article.subsections
                    ? this.renderSubsections(article.subsections)
                    : <p dangerouslySetInnerHTML={{ __html: article.body }} />
                }
            </div>
        ));
    }

    renderContent() {
        const { language } = this.props;
        const { content, error } = this.state;

        if (error) {
            return <p className="text-danger">Could not load terms content: {error}</p>;
        }

        if (!content) {
            return <p>Loading&hellip;</p>;
        }

        const key = language ? language.toLowerCase() : 'nl_be';
        const locale = content[key] || content['nl_be'];

        if (!locale) {
            return <p>No content available for locale: {key}</p>;
        }

        return (
            <>
                <h1>{locale.title}</h1>
                {this.renderArticles(locale.articles)}
            </>
        );
    }

    render() {
        return (
            <div className="container mb-5 mt-3">
                <div className="row">
                    <div className="col-12">
                        <div className="terms">
                            {this.renderContent()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Terms;